export default __webpack_public_path__ + "6c8e1d7ccc92d1bf041b746fb7b85e79.ttf";